import PropTypes from 'prop-types';
import React from 'react';

import * as Styled from './Author.styled';

/**
 * Renders an author name and role.
 * @param {string} name The author's name.
 * @param {string} role The author's role.
 * @param {string} className The className ref.
 */
const Author = ({ name = null, className = null }) => {
  return (
    <Styled.Container className={className}>
      {name && <Styled.Info>{name}</Styled.Info>}
    </Styled.Container>
  );
};

export const AuthorPropTypes = {
  /**
   * Author name.
   */
  name: PropTypes.string,
  /**
   * The className ref.
   */
  className: PropTypes.string,
};

Author.propTypes = AuthorPropTypes;

export default Author;
